import React, { Fragment, useState } from "react";
import { Title } from "./outlet.styles";
import {
  blue300,
  black700,
  borderLight,
  black600,
  green100,
} from "../../../theme/colors";
import { xsBold } from "../../../theme/typeface";
import styled from "styled-components";
import moment from "moment";
import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { GET_OUTLETS_DETAILS } from "../../../helpers/constants/apiUrl";
import themeSizes from "../../../theme/themeSizes";

const UserInititals = styled.span`
  width: 46px;
  height: 46px;
  font-weight: ${xsBold};
  font-size: 18px;
  line-height: 150%;
  color: ${black700};
  background: ${(props) => props.bgColor || "rgba(226, 58, 58, 0.2)"};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 23px;
`;

const RowWrapper = styled.div`
  padding: 18px 24px 12px 0;
  display: flex;
  justify-content: space-between;
  color: ${black600};
  > div {
    display: flex;
    align-items: flex-start;
    width:80%;
    @media ${themeSizes.mobile} {
      width:100% !important;
    }
    p {
      margin-left: 24px;
      font-size: 18px;
      line-height: 22px;
      width:calc(70% - 46px);
    }
  }
  p {
    font-size: 16px;
    line-height: 19px;
    width:20%;
  }
  border-bottom: 1px solid ${borderLight};
`;



const bgColor = ["rgba(226, 58, 58, 0.2)", "rgba(91, 127, 220, 0.2)", green100];

export const OutletLog = ({ logs, state, titel }) => {
  const [expandedLogs, setExpandedLogs] = useState({});
  const toggleExpand = (index) => {
    setExpandedLogs(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  function refresh_qc_data() {
    triggerSimpleAjax(
      `${GET_OUTLETS_DETAILS}${state.outletDetails.slug}/refresh-qc-data`,
      'GET',
      {},
      (response) => {
        window.location.reload()
      },
      (err) => {
        console.log(err)
      },
    )
  }
  return (
    <Fragment>
      <Title titleColor={blue300} titleFontWeight={xsBold}>
        {titel}
        <button
          style={{
            padding: '5px',
            border: "none",
            height: '20px',
            background: 'transparent',
          }}
          onClick={refresh_qc_data}
        >
          <img
            src="https://www.freeiconspng.com/uploads/arrow-refresh-reload-icon-30.png"
            height={"20px"}
            alt="Arrow Refresh Reload Icon"
            style={{ padding: '5px' }}
          />
        </button>
      </Title>
      {(logs || []).length ? (
        logs.map((log, index) => {
          const letters = log.message.slice(0, 2);
          if (!log.message.indexOf('kyc_re_audit_data_ingested') > -1) {
            log.message = log.message.replace('kyc_re_audit_data_ingested', 'Payout Return Reaudit')
          }
          const msg = log.message || "";
          const hasDescription = msg.includes("WIP_Description:");
          const firstPart = hasDescription ? msg.split("WIP_Description:")[0].replace(/_/g, ' ') : msg.replace(/_/g, ' ');
          const secondPart = hasDescription ? msg.split("WIP_Description:").slice(1).join("WIP_Description:") : "";
          const upadateDateAndTime = log.created
            ? moment(log.created).format("DD-MMM-YYYY hh:mm").split(" ")
            : "";
          return (
            <RowWrapper key={`${index}-${letters}`}>
              <div>
                <UserInititals bgColor={bgColor[index]}>
                  {letters.toUpperCase()}
                </UserInititals>
                {hasDescription ? (
                  <div style={{ marginLeft: "24px", width: "calc(70% - 46px)" }}>
                    <p style={{ whiteSpace: "pre-line", margin: 0, marginLeft: 0, width: "100%" }}>
                      {firstPart}
                      <span
                        onClick={() => toggleExpand(index)}
                        style={{
                          color: blue300,
                          cursor: "pointer",
                          fontWeight: "bold",
                          marginLeft: "8px",
                          textDecoration: "underline"
                        }}
                      >
                        {expandedLogs[index] ? "Read less" : "Read more"}
                      </span>
                    </p>
                    {expandedLogs[index] && (
                      <div style={{ marginTop: "8px" }} dangerouslySetInnerHTML={{ __html: secondPart }} />
                    )}
                  </div>
                ) : (
                  <p style={{ whiteSpace: "pre-line" }}>{firstPart}</p>
                )}
              </div>
              <p style={{ whiteSpace: "pre-line" }}>
                {upadateDateAndTime[0]} | {upadateDateAndTime.slice(1)}
              </p>
            </RowWrapper>
          );
        })
      ) : (
        <p>No Data Available</p>
      )}
    </Fragment>
  );
};
